export const typesOfIngDesk = {
  Agente: "Agente",
  Gestor: "Gestor",
  Supervisor: "Supervisor",
  Cliente: "Cliente",
};
export const ETipoIngDesk = {
  1: typesOfIngDesk.Agente,
  2: typesOfIngDesk.Gestor,
  3: typesOfIngDesk.Supervisor,
  4: typesOfIngDesk.Cliente,
};
